import React, { useState } from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';
import { useAppContext } from '../../contexts/AppContext';
export const DashboardLayout: React.FC = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const {
    state
  } = useAppContext();
  if (!state.isAuthenticated) {
    return <Navigate to="/login" replace data-id="element-240" />;
  }
  return <div className="min-h-screen bg-gray-50 flex" data-id="element-241">
      <Sidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} data-id="element-242" />

      <div className="flex-1 flex flex-col lg:pl-64 min-w-0 transition-all duration-300" data-id="element-243">
        <TopBar onMenuClick={() => setIsSidebarOpen(true)} data-id="element-244" />

        <main className="flex-1 p-4 sm:p-6 lg:p-8 overflow-x-hidden" data-id="element-245">
          <div className="max-w-7xl mx-auto" data-id="element-246">
            <Outlet data-id="element-247" />
          </div>
        </main>
      </div>
    </div>;
};